import React, { Component, Fragment } from "react";
import { Image } from "react-bootstrap";

import { setDateFormat, setDateTimeFormat } from "../../../../utils/index";

import statusInProgress from "../../../../assets/images/icon-status.svg";
import statusClosed from "../../../../assets/images/icon-bill-no-success.svg";
import statusCompleted from "../../../../assets/images/icon-bill-success.svg";

interface IParentProps {
  onBillClick: () => void;
  balanceBillHistory: {
    procedureLabel: string;
    patientName: string;
    dateOfService: string;
    facility: string;
    added: string;
    status: string;
    document: string;
  };
  t:any;
}
type Props = IParentProps;
class MyBill extends Component<Props> {
  state = {
    inputSearch: "",
  };
  handleActionChange = (e) => {};
  handleChange = (e) => {
    this.setState({
      inputSearch: e.target.value,
    });
  };

  billStatus = (balanceBillHistory) => {
    if (balanceBillHistory.status) {
      switch (balanceBillHistory.status.toLowerCase()) {
        case "closed".toLowerCase():
          return (
            <Image src={statusClosed} alt="stock-image" data-test="stockIMG" />
          );
        case "completed":
          return (
            <Image
              src={statusCompleted}
              alt="stock-image"
              data-test="stockIMG"
            />
          );
        case "current":
        case "in progress":
          return (
            <Image
              src={statusInProgress}
              alt="stock-image"
              data-test="stockIMG"
            />
          );
        default:
          return (
            <Image
              src={statusInProgress}
              alt="stock-image"
              data-test="stockIMG"
            />
          );
      }
    } else {
      return (
        <Image src={statusInProgress} alt="stock-image" data-test="stockIMG" />
      );
    }
  };
  render() {
    const {t} = this.props;
    const { onBillClick, balanceBillHistory } = { ...this.props };
    console.log("balancebillhistory", balanceBillHistory.added);
    console.log(" setDate balancebillhistory", setDateTimeFormat(balanceBillHistory.added));
    return (
      <Fragment>
        {/* <div className="bills-list" onClick={onBillClick}>
          <ul>
            <li>
              <h4 className="bill-title">
                {balanceBillHistory.procedureLabel} |{" "}
                <span>{balanceBillHistory.patientName}</span>
              </h4>
            </li>
            <li>
              <span className="text-secondary">Incident Date:</span>{" "}
              {setDateFormat(balanceBillHistory.dateOfService)}
            </li>
            <li>
              <span className="text-secondary">Facility:</span>{" "}
              {balanceBillHistory.facility}
            </li>
            <li>
              <span className="text-secondary">Added:</span>{" "}
              {setDateTimeFormat(balanceBillHistory.added)}
            </li>
          </ul>
          <div className="bill-status">
            {this.billStatus(balanceBillHistory)}
          </div>
        </div> */}
        <div onClick={onBillClick}>
          <div className="list-col-2 list-col-1">
            <div className="list-col2-inner">
              <ul>
                <li>
                  <h4 className="bill-title">
                    {balanceBillHistory.procedureLabel &&
                      balanceBillHistory.procedureLabel !== "" &&
                      `${balanceBillHistory.procedureLabel} | `}
                    <span>{balanceBillHistory.patientName}</span>
                  </h4>
                </li>
                <li>
                  <span className="text-secondary">{t('balanceBilling.incidentDate')}</span>{" "}
                  {setDateFormat(balanceBillHistory.dateOfService)}
                </li>
                <li>
                  <span className="text-secondary">{t('balanceBilling.facility')}</span>{" "}
                  {balanceBillHistory.facility}
                </li>
                <li>
                  <span className="text-secondary">{t('balanceBilling.added')}</span>{" "}
                  {setDateTimeFormat(balanceBillHistory.added)}
                </li>
              </ul>
              <div className="list-col-btn">
                <span className="pointer">
                  {this.billStatus(balanceBillHistory)}
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="list-col-2">
            <div className="list-col2-inner">
              <h6>Glendale Memorial Hospital</h6>
              <h5>John Doe</h5>
              <ul>
                <li><strong>Patient ID:<span>8675309123</span></strong></li>
                <li>Date of Service:<span>04/01/2020</span></li>
                <li>Bill Amount:<span>$00.00</span></li>
                <li>AMPS ID:<span>98387129874</span></li>
                <li>Claim #:<span>398278723823487</span></li>
              </ul>
              <div className="list-col-btn">
                <span className="pointer">
                  <Image src={statusCompleted} alt="statusCompleted" />
                </span>
              </div>
            </div>
          </div> */}

        {/* bills-section end */}
      </Fragment>
    );
  }
}

export default MyBill;
